import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ParcelCarrier = ({ carrierLogo, carrierName, carrierServiceName }) => {
  const theme = useTheme()

  return (
    <Styles.Container>
      {carrierLogo && <Styles.CarrierLogo src={carrierLogo} alt="carrier logo" />}
      <Text type="bodyMRegular">{carrierName}</Text>
      {carrierServiceName && (
        <>
          <Text type="bodyMRegular">|</Text>
          <Text type="bodyMRegular" color={theme.colors.text.subtle}>
            {carrierServiceName}
          </Text>
        </>
      )}
    </Styles.Container>
  )
}

export default ParcelCarrier
